/* eslint-disable */
const install = Vue => {
  if (install.installed) { return }

  install.installed = true

  Object.defineProperties(Vue.prototype, {
    // 注意，此处挂载在 Vue 原型的 $api 对象上
    $localStorage: {
      get () {
        let set = (key, value, expirse) => {
          let date = new Date()//时间
          let data = { value: value, expirse: new Date(date.setHours(date.getHours() + expirse)).getTime(), date: new Date().getTime() }
          localStorage.setItem(key, JSON.stringify(data))
        }
        let get = (key) => {
          let data = JSON.parse(localStorage.getItem(key))
          if (data !== null) {
            if (data.expirse != null && data.expirse < new Date().getTime()) {
              localStorage.removeItem(key)
            } else {
              return data.value
            }
          }
          return null
        }
        return { set, get }
      }
    }
  })
}
export default install


// WEBPACK FOOTER //
// ./src/utils/localStorage.js